function Ne(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: nt } = Object.prototype, { getPrototypeOf: de } = Object, G = /* @__PURE__ */ ((e) => (t) => {
  const r = nt.call(t);
  return e[r] || (e[r] = r.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), T = (e) => (e = e.toLowerCase(), (t) => G(t) === e), K = (e) => (t) => typeof t === e, { isArray: j } = Array, I = K("undefined");
function at(e) {
  return e !== null && !I(e) && e.constructor !== null && !I(e.constructor) && A(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const Ue = T("ArrayBuffer");
function st(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && Ue(e.buffer), t;
}
const ct = K("string"), A = K("function"), Fe = K("number"), X = (e) => e !== null && typeof e == "object", it = (e) => e === !0 || e === !1, z = (e) => {
  if (G(e) !== "object")
    return !1;
  const t = de(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, lt = T("Date"), ut = T("File"), ot = T("Blob"), dt = T("FileList"), ft = (e) => X(e) && A(e.pipe), mt = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || A(e.append) && ((t = G(e)) === "formdata" || // detect form-data instance
  t === "object" && A(e.toString) && e.toString() === "[object FormData]"));
}, ht = T("URLSearchParams"), [gt, bt, yt, wt] = ["ReadableStream", "Request", "Response", "Headers"].map(T), Ct = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function q(e, t, { allOwnKeys: r = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let n, a;
  if (typeof e != "object" && (e = [e]), j(e))
    for (n = 0, a = e.length; n < a; n++)
      t.call(null, e[n], n, e);
  else {
    const c = r ? Object.getOwnPropertyNames(e) : Object.keys(e), s = c.length;
    let i;
    for (n = 0; n < s; n++)
      i = c[n], t.call(null, e[i], i, e);
  }
}
function De(e, t) {
  t = t.toLowerCase();
  const r = Object.keys(e);
  let n = r.length, a;
  for (; n-- > 0; )
    if (a = r[n], t === a.toLowerCase())
      return a;
  return null;
}
const U = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, je = (e) => !I(e) && e !== U;
function ae() {
  const { caseless: e } = je(this) && this || {}, t = {}, r = (n, a) => {
    const c = e && De(t, a) || a;
    z(t[c]) && z(n) ? t[c] = ae(t[c], n) : z(n) ? t[c] = ae({}, n) : j(n) ? t[c] = n.slice() : t[c] = n;
  };
  for (let n = 0, a = arguments.length; n < a; n++)
    arguments[n] && q(arguments[n], r);
  return t;
}
const xt = (e, t, r, { allOwnKeys: n } = {}) => (q(t, (a, c) => {
  r && A(a) ? e[c] = Ne(a, r) : e[c] = a;
}, { allOwnKeys: n }), e), vt = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), Rt = (e, t, r, n) => {
  e.prototype = Object.create(t.prototype, n), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), r && Object.assign(e.prototype, r);
}, Et = (e, t, r, n) => {
  let a, c, s;
  const i = {};
  if (t = t || {}, e == null) return t;
  do {
    for (a = Object.getOwnPropertyNames(e), c = a.length; c-- > 0; )
      s = a[c], (!n || n(s, e, t)) && !i[s] && (t[s] = e[s], i[s] = !0);
    e = r !== !1 && de(e);
  } while (e && (!r || r(e, t)) && e !== Object.prototype);
  return t;
}, St = (e, t, r) => {
  e = String(e), (r === void 0 || r > e.length) && (r = e.length), r -= t.length;
  const n = e.indexOf(t, r);
  return n !== -1 && n === r;
}, _t = (e) => {
  if (!e) return null;
  if (j(e)) return e;
  let t = e.length;
  if (!Fe(t)) return null;
  const r = new Array(t);
  for (; t-- > 0; )
    r[t] = e[t];
  return r;
}, pt = /* @__PURE__ */ ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && de(Uint8Array)), At = (e, t) => {
  const n = (e && e[Symbol.iterator]).call(e);
  let a;
  for (; (a = n.next()) && !a.done; ) {
    const c = a.value;
    t.call(e, c[0], c[1]);
  }
}, Tt = (e, t) => {
  let r;
  const n = [];
  for (; (r = e.exec(t)) !== null; )
    n.push(r);
  return n;
}, Ot = T("HTMLFormElement"), Pt = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(r, n, a) {
    return n.toUpperCase() + a;
  }
), ye = (({ hasOwnProperty: e }) => (t, r) => e.call(t, r))(Object.prototype), Lt = T("RegExp"), Be = (e, t) => {
  const r = Object.getOwnPropertyDescriptors(e), n = {};
  q(r, (a, c) => {
    let s;
    (s = t(a, c, e)) !== !1 && (n[c] = s || a);
  }), Object.defineProperties(e, n);
}, Nt = (e) => {
  Be(e, (t, r) => {
    if (A(e) && ["arguments", "caller", "callee"].indexOf(r) !== -1)
      return !1;
    const n = e[r];
    if (A(n)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + r + "'");
      });
    }
  });
}, Ut = (e, t) => {
  const r = {}, n = (a) => {
    a.forEach((c) => {
      r[c] = !0;
    });
  };
  return j(e) ? n(e) : n(String(e).split(t)), r;
}, Ft = () => {
}, Dt = (e, t) => e != null && Number.isFinite(e = +e) ? e : t, ee = "abcdefghijklmnopqrstuvwxyz", we = "0123456789", ke = {
  DIGIT: we,
  ALPHA: ee,
  ALPHA_DIGIT: ee + ee.toUpperCase() + we
}, jt = (e = 16, t = ke.ALPHA_DIGIT) => {
  let r = "";
  const { length: n } = t;
  for (; e--; )
    r += t[Math.random() * n | 0];
  return r;
};
function Bt(e) {
  return !!(e && A(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
const kt = (e) => {
  const t = new Array(10), r = (n, a) => {
    if (X(n)) {
      if (t.indexOf(n) >= 0)
        return;
      if (!("toJSON" in n)) {
        t[a] = n;
        const c = j(n) ? [] : {};
        return q(n, (s, i) => {
          const f = r(s, a + 1);
          !I(f) && (c[i] = f);
        }), t[a] = void 0, c;
      }
    }
    return n;
  };
  return r(e, 0);
}, It = T("AsyncFunction"), qt = (e) => e && (X(e) || A(e)) && A(e.then) && A(e.catch), Ie = ((e, t) => e ? setImmediate : t ? ((r, n) => (U.addEventListener("message", ({ source: a, data: c }) => {
  a === U && c === r && n.length && n.shift()();
}, !1), (a) => {
  n.push(a), U.postMessage(r, "*");
}))(`axios@${Math.random()}`, []) : (r) => setTimeout(r))(
  typeof setImmediate == "function",
  A(U.postMessage)
), Ht = typeof queueMicrotask < "u" ? queueMicrotask.bind(U) : typeof process < "u" && process.nextTick || Ie, l = {
  isArray: j,
  isArrayBuffer: Ue,
  isBuffer: at,
  isFormData: mt,
  isArrayBufferView: st,
  isString: ct,
  isNumber: Fe,
  isBoolean: it,
  isObject: X,
  isPlainObject: z,
  isReadableStream: gt,
  isRequest: bt,
  isResponse: yt,
  isHeaders: wt,
  isUndefined: I,
  isDate: lt,
  isFile: ut,
  isBlob: ot,
  isRegExp: Lt,
  isFunction: A,
  isStream: ft,
  isURLSearchParams: ht,
  isTypedArray: pt,
  isFileList: dt,
  forEach: q,
  merge: ae,
  extend: xt,
  trim: Ct,
  stripBOM: vt,
  inherits: Rt,
  toFlatObject: Et,
  kindOf: G,
  kindOfTest: T,
  endsWith: St,
  toArray: _t,
  forEachEntry: At,
  matchAll: Tt,
  isHTMLForm: Ot,
  hasOwnProperty: ye,
  hasOwnProp: ye,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: Be,
  freezeMethods: Nt,
  toObjectSet: Ut,
  toCamelCase: Pt,
  noop: Ft,
  toFiniteNumber: Dt,
  findKey: De,
  global: U,
  isContextDefined: je,
  ALPHABET: ke,
  generateString: jt,
  isSpecCompliantForm: Bt,
  toJSONObject: kt,
  isAsyncFn: It,
  isThenable: qt,
  setImmediate: Ie,
  asap: Ht
};
function b(e, t, r, n, a) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), r && (this.config = r), n && (this.request = n), a && (this.response = a, this.status = a.status ? a.status : null);
}
l.inherits(b, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: l.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const qe = b.prototype, He = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  He[e] = { value: e };
});
Object.defineProperties(b, He);
Object.defineProperty(qe, "isAxiosError", { value: !0 });
b.from = (e, t, r, n, a, c) => {
  const s = Object.create(qe);
  return l.toFlatObject(e, s, function(f) {
    return f !== Error.prototype;
  }, (i) => i !== "isAxiosError"), b.call(s, e.message, t, r, n, a), s.cause = e, s.name = e.name, c && Object.assign(s, c), s;
};
const Mt = null;
function se(e) {
  return l.isPlainObject(e) || l.isArray(e);
}
function Me(e) {
  return l.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function Ce(e, t, r) {
  return e ? e.concat(t).map(function(a, c) {
    return a = Me(a), !r && c ? "[" + a + "]" : a;
  }).join(r ? "." : "") : t;
}
function zt(e) {
  return l.isArray(e) && !e.some(se);
}
const $t = l.toFlatObject(l, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
});
function Q(e, t, r) {
  if (!l.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), r = l.toFlatObject(r, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(y, g) {
    return !l.isUndefined(g[y]);
  });
  const n = r.metaTokens, a = r.visitor || d, c = r.dots, s = r.indexes, f = (r.Blob || typeof Blob < "u" && Blob) && l.isSpecCompliantForm(t);
  if (!l.isFunction(a))
    throw new TypeError("visitor must be a function");
  function o(h) {
    if (h === null) return "";
    if (l.isDate(h))
      return h.toISOString();
    if (!f && l.isBlob(h))
      throw new b("Blob is not supported. Use a Buffer instead.");
    return l.isArrayBuffer(h) || l.isTypedArray(h) ? f && typeof Blob == "function" ? new Blob([h]) : Buffer.from(h) : h;
  }
  function d(h, y, g) {
    let C = h;
    if (h && !g && typeof h == "object") {
      if (l.endsWith(y, "{}"))
        y = n ? y : y.slice(0, -2), h = JSON.stringify(h);
      else if (l.isArray(h) && zt(h) || (l.isFileList(h) || l.endsWith(y, "[]")) && (C = l.toArray(h)))
        return y = Me(y), C.forEach(function(E, P) {
          !(l.isUndefined(E) || E === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            s === !0 ? Ce([y], P, c) : s === null ? y : y + "[]",
            o(E)
          );
        }), !1;
    }
    return se(h) ? !0 : (t.append(Ce(g, y, c), o(h)), !1);
  }
  const m = [], w = Object.assign($t, {
    defaultVisitor: d,
    convertValue: o,
    isVisitable: se
  });
  function v(h, y) {
    if (!l.isUndefined(h)) {
      if (m.indexOf(h) !== -1)
        throw Error("Circular reference detected in " + y.join("."));
      m.push(h), l.forEach(h, function(C, R) {
        (!(l.isUndefined(C) || C === null) && a.call(
          t,
          C,
          l.isString(R) ? R.trim() : R,
          y,
          w
        )) === !0 && v(C, y ? y.concat(R) : [R]);
      }), m.pop();
    }
  }
  if (!l.isObject(e))
    throw new TypeError("data must be an object");
  return v(e), t;
}
function xe(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(n) {
    return t[n];
  });
}
function fe(e, t) {
  this._pairs = [], e && Q(e, this, t);
}
const ze = fe.prototype;
ze.append = function(t, r) {
  this._pairs.push([t, r]);
};
ze.toString = function(t) {
  const r = t ? function(n) {
    return t.call(this, n, xe);
  } : xe;
  return this._pairs.map(function(a) {
    return r(a[0]) + "=" + r(a[1]);
  }, "").join("&");
};
function Jt(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function $e(e, t, r) {
  if (!t)
    return e;
  const n = r && r.encode || Jt;
  l.isFunction(r) && (r = {
    serialize: r
  });
  const a = r && r.serialize;
  let c;
  if (a ? c = a(t, r) : c = l.isURLSearchParams(t) ? t.toString() : new fe(t, r).toString(n), c) {
    const s = e.indexOf("#");
    s !== -1 && (e = e.slice(0, s)), e += (e.indexOf("?") === -1 ? "?" : "&") + c;
  }
  return e;
}
class ve {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, r, n) {
    return this.handlers.push({
      fulfilled: t,
      rejected: r,
      synchronous: n ? n.synchronous : !1,
      runWhen: n ? n.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    l.forEach(this.handlers, function(n) {
      n !== null && t(n);
    });
  }
}
const Je = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, Vt = typeof URLSearchParams < "u" ? URLSearchParams : fe, Wt = typeof FormData < "u" ? FormData : null, Gt = typeof Blob < "u" ? Blob : null, Kt = {
  isBrowser: !0,
  classes: {
    URLSearchParams: Vt,
    FormData: Wt,
    Blob: Gt
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, me = typeof window < "u" && typeof document < "u", ce = typeof navigator == "object" && navigator || void 0, Xt = me && (!ce || ["ReactNative", "NativeScript", "NS"].indexOf(ce.product) < 0), Qt = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", Zt = me && window.location.href || "http://localhost", Yt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: me,
  hasStandardBrowserEnv: Xt,
  hasStandardBrowserWebWorkerEnv: Qt,
  navigator: ce,
  origin: Zt
}, Symbol.toStringTag, { value: "Module" })), S = {
  ...Yt,
  ...Kt
};
function er(e, t) {
  return Q(e, new S.classes.URLSearchParams(), Object.assign({
    visitor: function(r, n, a, c) {
      return S.isNode && l.isBuffer(r) ? (this.append(n, r.toString("base64")), !1) : c.defaultVisitor.apply(this, arguments);
    }
  }, t));
}
function tr(e) {
  return l.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function rr(e) {
  const t = {}, r = Object.keys(e);
  let n;
  const a = r.length;
  let c;
  for (n = 0; n < a; n++)
    c = r[n], t[c] = e[c];
  return t;
}
function Ve(e) {
  function t(r, n, a, c) {
    let s = r[c++];
    if (s === "__proto__") return !0;
    const i = Number.isFinite(+s), f = c >= r.length;
    return s = !s && l.isArray(a) ? a.length : s, f ? (l.hasOwnProp(a, s) ? a[s] = [a[s], n] : a[s] = n, !i) : ((!a[s] || !l.isObject(a[s])) && (a[s] = []), t(r, n, a[s], c) && l.isArray(a[s]) && (a[s] = rr(a[s])), !i);
  }
  if (l.isFormData(e) && l.isFunction(e.entries)) {
    const r = {};
    return l.forEachEntry(e, (n, a) => {
      t(tr(n), a, r, 0);
    }), r;
  }
  return null;
}
function nr(e, t, r) {
  if (l.isString(e))
    try {
      return (t || JSON.parse)(e), l.trim(e);
    } catch (n) {
      if (n.name !== "SyntaxError")
        throw n;
    }
  return (0, JSON.stringify)(e);
}
const H = {
  transitional: Je,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(t, r) {
    const n = r.getContentType() || "", a = n.indexOf("application/json") > -1, c = l.isObject(t);
    if (c && l.isHTMLForm(t) && (t = new FormData(t)), l.isFormData(t))
      return a ? JSON.stringify(Ve(t)) : t;
    if (l.isArrayBuffer(t) || l.isBuffer(t) || l.isStream(t) || l.isFile(t) || l.isBlob(t) || l.isReadableStream(t))
      return t;
    if (l.isArrayBufferView(t))
      return t.buffer;
    if (l.isURLSearchParams(t))
      return r.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
    let i;
    if (c) {
      if (n.indexOf("application/x-www-form-urlencoded") > -1)
        return er(t, this.formSerializer).toString();
      if ((i = l.isFileList(t)) || n.indexOf("multipart/form-data") > -1) {
        const f = this.env && this.env.FormData;
        return Q(
          i ? { "files[]": t } : t,
          f && new f(),
          this.formSerializer
        );
      }
    }
    return c || a ? (r.setContentType("application/json", !1), nr(t)) : t;
  }],
  transformResponse: [function(t) {
    const r = this.transitional || H.transitional, n = r && r.forcedJSONParsing, a = this.responseType === "json";
    if (l.isResponse(t) || l.isReadableStream(t))
      return t;
    if (t && l.isString(t) && (n && !this.responseType || a)) {
      const s = !(r && r.silentJSONParsing) && a;
      try {
        return JSON.parse(t);
      } catch (i) {
        if (s)
          throw i.name === "SyntaxError" ? b.from(i, b.ERR_BAD_RESPONSE, this, null, this.response) : i;
      }
    }
    return t;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: S.classes.FormData,
    Blob: S.classes.Blob
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
l.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  H.headers[e] = {};
});
const ar = l.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), sr = (e) => {
  const t = {};
  let r, n, a;
  return e && e.split(`
`).forEach(function(s) {
    a = s.indexOf(":"), r = s.substring(0, a).trim().toLowerCase(), n = s.substring(a + 1).trim(), !(!r || t[r] && ar[r]) && (r === "set-cookie" ? t[r] ? t[r].push(n) : t[r] = [n] : t[r] = t[r] ? t[r] + ", " + n : n);
  }), t;
}, Re = Symbol("internals");
function k(e) {
  return e && String(e).trim().toLowerCase();
}
function $(e) {
  return e === !1 || e == null ? e : l.isArray(e) ? e.map($) : String(e);
}
function cr(e) {
  const t = /* @__PURE__ */ Object.create(null), r = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let n;
  for (; n = r.exec(e); )
    t[n[1]] = n[2];
  return t;
}
const ir = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function te(e, t, r, n, a) {
  if (l.isFunction(n))
    return n.call(this, t, r);
  if (a && (t = r), !!l.isString(t)) {
    if (l.isString(n))
      return t.indexOf(n) !== -1;
    if (l.isRegExp(n))
      return n.test(t);
  }
}
function lr(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, r, n) => r.toUpperCase() + n);
}
function ur(e, t) {
  const r = l.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((n) => {
    Object.defineProperty(e, n + r, {
      value: function(a, c, s) {
        return this[n].call(this, t, a, c, s);
      },
      configurable: !0
    });
  });
}
class p {
  constructor(t) {
    t && this.set(t);
  }
  set(t, r, n) {
    const a = this;
    function c(i, f, o) {
      const d = k(f);
      if (!d)
        throw new Error("header name must be a non-empty string");
      const m = l.findKey(a, d);
      (!m || a[m] === void 0 || o === !0 || o === void 0 && a[m] !== !1) && (a[m || f] = $(i));
    }
    const s = (i, f) => l.forEach(i, (o, d) => c(o, d, f));
    if (l.isPlainObject(t) || t instanceof this.constructor)
      s(t, r);
    else if (l.isString(t) && (t = t.trim()) && !ir(t))
      s(sr(t), r);
    else if (l.isHeaders(t))
      for (const [i, f] of t.entries())
        c(f, i, n);
    else
      t != null && c(r, t, n);
    return this;
  }
  get(t, r) {
    if (t = k(t), t) {
      const n = l.findKey(this, t);
      if (n) {
        const a = this[n];
        if (!r)
          return a;
        if (r === !0)
          return cr(a);
        if (l.isFunction(r))
          return r.call(this, a, n);
        if (l.isRegExp(r))
          return r.exec(a);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, r) {
    if (t = k(t), t) {
      const n = l.findKey(this, t);
      return !!(n && this[n] !== void 0 && (!r || te(this, this[n], n, r)));
    }
    return !1;
  }
  delete(t, r) {
    const n = this;
    let a = !1;
    function c(s) {
      if (s = k(s), s) {
        const i = l.findKey(n, s);
        i && (!r || te(n, n[i], i, r)) && (delete n[i], a = !0);
      }
    }
    return l.isArray(t) ? t.forEach(c) : c(t), a;
  }
  clear(t) {
    const r = Object.keys(this);
    let n = r.length, a = !1;
    for (; n--; ) {
      const c = r[n];
      (!t || te(this, this[c], c, t, !0)) && (delete this[c], a = !0);
    }
    return a;
  }
  normalize(t) {
    const r = this, n = {};
    return l.forEach(this, (a, c) => {
      const s = l.findKey(n, c);
      if (s) {
        r[s] = $(a), delete r[c];
        return;
      }
      const i = t ? lr(c) : String(c).trim();
      i !== c && delete r[c], r[i] = $(a), n[i] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const r = /* @__PURE__ */ Object.create(null);
    return l.forEach(this, (n, a) => {
      n != null && n !== !1 && (r[a] = t && l.isArray(n) ? n.join(", ") : n);
    }), r;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, r]) => t + ": " + r).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...r) {
    const n = new this(t);
    return r.forEach((a) => n.set(a)), n;
  }
  static accessor(t) {
    const n = (this[Re] = this[Re] = {
      accessors: {}
    }).accessors, a = this.prototype;
    function c(s) {
      const i = k(s);
      n[i] || (ur(a, s), n[i] = !0);
    }
    return l.isArray(t) ? t.forEach(c) : c(t), this;
  }
}
p.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
l.reduceDescriptors(p.prototype, ({ value: e }, t) => {
  let r = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(n) {
      this[r] = n;
    }
  };
});
l.freezeMethods(p);
function re(e, t) {
  const r = this || H, n = t || r, a = p.from(n.headers);
  let c = n.data;
  return l.forEach(e, function(i) {
    c = i.call(r, c, a.normalize(), t ? t.status : void 0);
  }), a.normalize(), c;
}
function We(e) {
  return !!(e && e.__CANCEL__);
}
function B(e, t, r) {
  b.call(this, e ?? "canceled", b.ERR_CANCELED, t, r), this.name = "CanceledError";
}
l.inherits(B, b, {
  __CANCEL__: !0
});
function Ge(e, t, r) {
  const n = r.config.validateStatus;
  !r.status || !n || n(r.status) ? e(r) : t(new b(
    "Request failed with status code " + r.status,
    [b.ERR_BAD_REQUEST, b.ERR_BAD_RESPONSE][Math.floor(r.status / 100) - 4],
    r.config,
    r.request,
    r
  ));
}
function or(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function dr(e, t) {
  e = e || 10;
  const r = new Array(e), n = new Array(e);
  let a = 0, c = 0, s;
  return t = t !== void 0 ? t : 1e3, function(f) {
    const o = Date.now(), d = n[c];
    s || (s = o), r[a] = f, n[a] = o;
    let m = c, w = 0;
    for (; m !== a; )
      w += r[m++], m = m % e;
    if (a = (a + 1) % e, a === c && (c = (c + 1) % e), o - s < t)
      return;
    const v = d && o - d;
    return v ? Math.round(w * 1e3 / v) : void 0;
  };
}
function fr(e, t) {
  let r = 0, n = 1e3 / t, a, c;
  const s = (o, d = Date.now()) => {
    r = d, a = null, c && (clearTimeout(c), c = null), e.apply(null, o);
  };
  return [(...o) => {
    const d = Date.now(), m = d - r;
    m >= n ? s(o, d) : (a = o, c || (c = setTimeout(() => {
      c = null, s(a);
    }, n - m)));
  }, () => a && s(a)];
}
const V = (e, t, r = 3) => {
  let n = 0;
  const a = dr(50, 250);
  return fr((c) => {
    const s = c.loaded, i = c.lengthComputable ? c.total : void 0, f = s - n, o = a(f), d = s <= i;
    n = s;
    const m = {
      loaded: s,
      total: i,
      progress: i ? s / i : void 0,
      bytes: f,
      rate: o || void 0,
      estimated: o && i && d ? (i - s) / o : void 0,
      event: c,
      lengthComputable: i != null,
      [t ? "download" : "upload"]: !0
    };
    e(m);
  }, r);
}, Ee = (e, t) => {
  const r = e != null;
  return [(n) => t[0]({
    lengthComputable: r,
    total: e,
    loaded: n
  }), t[1]];
}, Se = (e) => (...t) => l.asap(() => e(...t)), mr = S.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, t) => (r) => (r = new URL(r, S.origin), e.protocol === r.protocol && e.host === r.host && (t || e.port === r.port)))(
  new URL(S.origin),
  S.navigator && /(msie|trident)/i.test(S.navigator.userAgent)
) : () => !0, hr = S.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, r, n, a, c) {
      const s = [e + "=" + encodeURIComponent(t)];
      l.isNumber(r) && s.push("expires=" + new Date(r).toGMTString()), l.isString(n) && s.push("path=" + n), l.isString(a) && s.push("domain=" + a), c === !0 && s.push("secure"), document.cookie = s.join("; ");
    },
    read(e) {
      const t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return t ? decodeURIComponent(t[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function gr(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function br(e, t) {
  return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function Ke(e, t) {
  return e && !gr(t) ? br(e, t) : t;
}
const _e = (e) => e instanceof p ? { ...e } : e;
function D(e, t) {
  t = t || {};
  const r = {};
  function n(o, d, m, w) {
    return l.isPlainObject(o) && l.isPlainObject(d) ? l.merge.call({ caseless: w }, o, d) : l.isPlainObject(d) ? l.merge({}, d) : l.isArray(d) ? d.slice() : d;
  }
  function a(o, d, m, w) {
    if (l.isUndefined(d)) {
      if (!l.isUndefined(o))
        return n(void 0, o, m, w);
    } else return n(o, d, m, w);
  }
  function c(o, d) {
    if (!l.isUndefined(d))
      return n(void 0, d);
  }
  function s(o, d) {
    if (l.isUndefined(d)) {
      if (!l.isUndefined(o))
        return n(void 0, o);
    } else return n(void 0, d);
  }
  function i(o, d, m) {
    if (m in t)
      return n(o, d);
    if (m in e)
      return n(void 0, o);
  }
  const f = {
    url: c,
    method: c,
    data: c,
    baseURL: s,
    transformRequest: s,
    transformResponse: s,
    paramsSerializer: s,
    timeout: s,
    timeoutMessage: s,
    withCredentials: s,
    withXSRFToken: s,
    adapter: s,
    responseType: s,
    xsrfCookieName: s,
    xsrfHeaderName: s,
    onUploadProgress: s,
    onDownloadProgress: s,
    decompress: s,
    maxContentLength: s,
    maxBodyLength: s,
    beforeRedirect: s,
    transport: s,
    httpAgent: s,
    httpsAgent: s,
    cancelToken: s,
    socketPath: s,
    responseEncoding: s,
    validateStatus: i,
    headers: (o, d, m) => a(_e(o), _e(d), m, !0)
  };
  return l.forEach(Object.keys(Object.assign({}, e, t)), function(d) {
    const m = f[d] || a, w = m(e[d], t[d], d);
    l.isUndefined(w) && m !== i || (r[d] = w);
  }), r;
}
const Xe = (e) => {
  const t = D({}, e);
  let { data: r, withXSRFToken: n, xsrfHeaderName: a, xsrfCookieName: c, headers: s, auth: i } = t;
  t.headers = s = p.from(s), t.url = $e(Ke(t.baseURL, t.url), e.params, e.paramsSerializer), i && s.set(
    "Authorization",
    "Basic " + btoa((i.username || "") + ":" + (i.password ? unescape(encodeURIComponent(i.password)) : ""))
  );
  let f;
  if (l.isFormData(r)) {
    if (S.hasStandardBrowserEnv || S.hasStandardBrowserWebWorkerEnv)
      s.setContentType(void 0);
    else if ((f = s.getContentType()) !== !1) {
      const [o, ...d] = f ? f.split(";").map((m) => m.trim()).filter(Boolean) : [];
      s.setContentType([o || "multipart/form-data", ...d].join("; "));
    }
  }
  if (S.hasStandardBrowserEnv && (n && l.isFunction(n) && (n = n(t)), n || n !== !1 && mr(t.url))) {
    const o = a && c && hr.read(c);
    o && s.set(a, o);
  }
  return t;
}, yr = typeof XMLHttpRequest < "u", wr = yr && function(e) {
  return new Promise(function(r, n) {
    const a = Xe(e);
    let c = a.data;
    const s = p.from(a.headers).normalize();
    let { responseType: i, onUploadProgress: f, onDownloadProgress: o } = a, d, m, w, v, h;
    function y() {
      v && v(), h && h(), a.cancelToken && a.cancelToken.unsubscribe(d), a.signal && a.signal.removeEventListener("abort", d);
    }
    let g = new XMLHttpRequest();
    g.open(a.method.toUpperCase(), a.url, !0), g.timeout = a.timeout;
    function C() {
      if (!g)
        return;
      const E = p.from(
        "getAllResponseHeaders" in g && g.getAllResponseHeaders()
      ), _ = {
        data: !i || i === "text" || i === "json" ? g.responseText : g.response,
        status: g.status,
        statusText: g.statusText,
        headers: E,
        config: e,
        request: g
      };
      Ge(function(N) {
        r(N), y();
      }, function(N) {
        n(N), y();
      }, _), g = null;
    }
    "onloadend" in g ? g.onloadend = C : g.onreadystatechange = function() {
      !g || g.readyState !== 4 || g.status === 0 && !(g.responseURL && g.responseURL.indexOf("file:") === 0) || setTimeout(C);
    }, g.onabort = function() {
      g && (n(new b("Request aborted", b.ECONNABORTED, e, g)), g = null);
    }, g.onerror = function() {
      n(new b("Network Error", b.ERR_NETWORK, e, g)), g = null;
    }, g.ontimeout = function() {
      let P = a.timeout ? "timeout of " + a.timeout + "ms exceeded" : "timeout exceeded";
      const _ = a.transitional || Je;
      a.timeoutErrorMessage && (P = a.timeoutErrorMessage), n(new b(
        P,
        _.clarifyTimeoutError ? b.ETIMEDOUT : b.ECONNABORTED,
        e,
        g
      )), g = null;
    }, c === void 0 && s.setContentType(null), "setRequestHeader" in g && l.forEach(s.toJSON(), function(P, _) {
      g.setRequestHeader(_, P);
    }), l.isUndefined(a.withCredentials) || (g.withCredentials = !!a.withCredentials), i && i !== "json" && (g.responseType = a.responseType), o && ([w, h] = V(o, !0), g.addEventListener("progress", w)), f && g.upload && ([m, v] = V(f), g.upload.addEventListener("progress", m), g.upload.addEventListener("loadend", v)), (a.cancelToken || a.signal) && (d = (E) => {
      g && (n(!E || E.type ? new B(null, e, g) : E), g.abort(), g = null);
    }, a.cancelToken && a.cancelToken.subscribe(d), a.signal && (a.signal.aborted ? d() : a.signal.addEventListener("abort", d)));
    const R = or(a.url);
    if (R && S.protocols.indexOf(R) === -1) {
      n(new b("Unsupported protocol " + R + ":", b.ERR_BAD_REQUEST, e));
      return;
    }
    g.send(c || null);
  });
}, Cr = (e, t) => {
  const { length: r } = e = e ? e.filter(Boolean) : [];
  if (t || r) {
    let n = new AbortController(), a;
    const c = function(o) {
      if (!a) {
        a = !0, i();
        const d = o instanceof Error ? o : this.reason;
        n.abort(d instanceof b ? d : new B(d instanceof Error ? d.message : d));
      }
    };
    let s = t && setTimeout(() => {
      s = null, c(new b(`timeout ${t} of ms exceeded`, b.ETIMEDOUT));
    }, t);
    const i = () => {
      e && (s && clearTimeout(s), s = null, e.forEach((o) => {
        o.unsubscribe ? o.unsubscribe(c) : o.removeEventListener("abort", c);
      }), e = null);
    };
    e.forEach((o) => o.addEventListener("abort", c));
    const { signal: f } = n;
    return f.unsubscribe = () => l.asap(i), f;
  }
}, xr = function* (e, t) {
  let r = e.byteLength;
  if (r < t) {
    yield e;
    return;
  }
  let n = 0, a;
  for (; n < r; )
    a = n + t, yield e.slice(n, a), n = a;
}, vr = async function* (e, t) {
  for await (const r of Rr(e))
    yield* xr(r, t);
}, Rr = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const t = e.getReader();
  try {
    for (; ; ) {
      const { done: r, value: n } = await t.read();
      if (r)
        break;
      yield n;
    }
  } finally {
    await t.cancel();
  }
}, pe = (e, t, r, n) => {
  const a = vr(e, t);
  let c = 0, s, i = (f) => {
    s || (s = !0, n && n(f));
  };
  return new ReadableStream({
    async pull(f) {
      try {
        const { done: o, value: d } = await a.next();
        if (o) {
          i(), f.close();
          return;
        }
        let m = d.byteLength;
        if (r) {
          let w = c += m;
          r(w);
        }
        f.enqueue(new Uint8Array(d));
      } catch (o) {
        throw i(o), o;
      }
    },
    cancel(f) {
      return i(f), a.return();
    }
  }, {
    highWaterMark: 2
  });
}, Z = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function", Qe = Z && typeof ReadableStream == "function", Er = Z && (typeof TextEncoder == "function" ? /* @__PURE__ */ ((e) => (t) => e.encode(t))(new TextEncoder()) : async (e) => new Uint8Array(await new Response(e).arrayBuffer())), Ze = (e, ...t) => {
  try {
    return !!e(...t);
  } catch {
    return !1;
  }
}, Sr = Qe && Ze(() => {
  let e = !1;
  const t = new Request(S.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      return e = !0, "half";
    }
  }).headers.has("Content-Type");
  return e && !t;
}), Ae = 64 * 1024, ie = Qe && Ze(() => l.isReadableStream(new Response("").body)), W = {
  stream: ie && ((e) => e.body)
};
Z && ((e) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((t) => {
    !W[t] && (W[t] = l.isFunction(e[t]) ? (r) => r[t]() : (r, n) => {
      throw new b(`Response type '${t}' is not supported`, b.ERR_NOT_SUPPORT, n);
    });
  });
})(new Response());
const _r = async (e) => {
  if (e == null)
    return 0;
  if (l.isBlob(e))
    return e.size;
  if (l.isSpecCompliantForm(e))
    return (await new Request(S.origin, {
      method: "POST",
      body: e
    }).arrayBuffer()).byteLength;
  if (l.isArrayBufferView(e) || l.isArrayBuffer(e))
    return e.byteLength;
  if (l.isURLSearchParams(e) && (e = e + ""), l.isString(e))
    return (await Er(e)).byteLength;
}, pr = async (e, t) => {
  const r = l.toFiniteNumber(e.getContentLength());
  return r ?? _r(t);
}, Ar = Z && (async (e) => {
  let {
    url: t,
    method: r,
    data: n,
    signal: a,
    cancelToken: c,
    timeout: s,
    onDownloadProgress: i,
    onUploadProgress: f,
    responseType: o,
    headers: d,
    withCredentials: m = "same-origin",
    fetchOptions: w
  } = Xe(e);
  o = o ? (o + "").toLowerCase() : "text";
  let v = Cr([a, c && c.toAbortSignal()], s), h;
  const y = v && v.unsubscribe && (() => {
    v.unsubscribe();
  });
  let g;
  try {
    if (f && Sr && r !== "get" && r !== "head" && (g = await pr(d, n)) !== 0) {
      let _ = new Request(t, {
        method: "POST",
        body: n,
        duplex: "half"
      }), L;
      if (l.isFormData(n) && (L = _.headers.get("content-type")) && d.setContentType(L), _.body) {
        const [N, M] = Ee(
          g,
          V(Se(f))
        );
        n = pe(_.body, Ae, N, M);
      }
    }
    l.isString(m) || (m = m ? "include" : "omit");
    const C = "credentials" in Request.prototype;
    h = new Request(t, {
      ...w,
      signal: v,
      method: r.toUpperCase(),
      headers: d.normalize().toJSON(),
      body: n,
      duplex: "half",
      credentials: C ? m : void 0
    });
    let R = await fetch(h);
    const E = ie && (o === "stream" || o === "response");
    if (ie && (i || E && y)) {
      const _ = {};
      ["status", "statusText", "headers"].forEach((be) => {
        _[be] = R[be];
      });
      const L = l.toFiniteNumber(R.headers.get("content-length")), [N, M] = i && Ee(
        L,
        V(Se(i), !0)
      ) || [];
      R = new Response(
        pe(R.body, Ae, N, () => {
          M && M(), y && y();
        }),
        _
      );
    }
    o = o || "text";
    let P = await W[l.findKey(W, o) || "text"](R, e);
    return !E && y && y(), await new Promise((_, L) => {
      Ge(_, L, {
        data: P,
        headers: p.from(R.headers),
        status: R.status,
        statusText: R.statusText,
        config: e,
        request: h
      });
    });
  } catch (C) {
    throw y && y(), C && C.name === "TypeError" && /fetch/i.test(C.message) ? Object.assign(
      new b("Network Error", b.ERR_NETWORK, e, h),
      {
        cause: C.cause || C
      }
    ) : b.from(C, C && C.code, e, h);
  }
}), le = {
  http: Mt,
  xhr: wr,
  fetch: Ar
};
l.forEach(le, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const Te = (e) => `- ${e}`, Tr = (e) => l.isFunction(e) || e === null || e === !1, Ye = {
  getAdapter: (e) => {
    e = l.isArray(e) ? e : [e];
    const { length: t } = e;
    let r, n;
    const a = {};
    for (let c = 0; c < t; c++) {
      r = e[c];
      let s;
      if (n = r, !Tr(r) && (n = le[(s = String(r)).toLowerCase()], n === void 0))
        throw new b(`Unknown adapter '${s}'`);
      if (n)
        break;
      a[s || "#" + c] = n;
    }
    if (!n) {
      const c = Object.entries(a).map(
        ([i, f]) => `adapter ${i} ` + (f === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let s = t ? c.length > 1 ? `since :
` + c.map(Te).join(`
`) : " " + Te(c[0]) : "as no adapter specified";
      throw new b(
        "There is no suitable adapter to dispatch the request " + s,
        "ERR_NOT_SUPPORT"
      );
    }
    return n;
  },
  adapters: le
};
function ne(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new B(null, e);
}
function Oe(e) {
  return ne(e), e.headers = p.from(e.headers), e.data = re.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), Ye.getAdapter(e.adapter || H.adapter)(e).then(function(n) {
    return ne(e), n.data = re.call(
      e,
      e.transformResponse,
      n
    ), n.headers = p.from(n.headers), n;
  }, function(n) {
    return We(n) || (ne(e), n && n.response && (n.response.data = re.call(
      e,
      e.transformResponse,
      n.response
    ), n.response.headers = p.from(n.response.headers))), Promise.reject(n);
  });
}
const et = "1.7.9", Y = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  Y[e] = function(n) {
    return typeof n === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const Pe = {};
Y.transitional = function(t, r, n) {
  function a(c, s) {
    return "[Axios v" + et + "] Transitional option '" + c + "'" + s + (n ? ". " + n : "");
  }
  return (c, s, i) => {
    if (t === !1)
      throw new b(
        a(s, " has been removed" + (r ? " in " + r : "")),
        b.ERR_DEPRECATED
      );
    return r && !Pe[s] && (Pe[s] = !0, console.warn(
      a(
        s,
        " has been deprecated since v" + r + " and will be removed in the near future"
      )
    )), t ? t(c, s, i) : !0;
  };
};
Y.spelling = function(t) {
  return (r, n) => (console.warn(`${n} is likely a misspelling of ${t}`), !0);
};
function Or(e, t, r) {
  if (typeof e != "object")
    throw new b("options must be an object", b.ERR_BAD_OPTION_VALUE);
  const n = Object.keys(e);
  let a = n.length;
  for (; a-- > 0; ) {
    const c = n[a], s = t[c];
    if (s) {
      const i = e[c], f = i === void 0 || s(i, c, e);
      if (f !== !0)
        throw new b("option " + c + " must be " + f, b.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (r !== !0)
      throw new b("Unknown option " + c, b.ERR_BAD_OPTION);
  }
}
const J = {
  assertOptions: Or,
  validators: Y
}, O = J.validators;
class F {
  constructor(t) {
    this.defaults = t, this.interceptors = {
      request: new ve(),
      response: new ve()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(t, r) {
    try {
      return await this._request(t, r);
    } catch (n) {
      if (n instanceof Error) {
        let a = {};
        Error.captureStackTrace ? Error.captureStackTrace(a) : a = new Error();
        const c = a.stack ? a.stack.replace(/^.+\n/, "") : "";
        try {
          n.stack ? c && !String(n.stack).endsWith(c.replace(/^.+\n.+\n/, "")) && (n.stack += `
` + c) : n.stack = c;
        } catch {
        }
      }
      throw n;
    }
  }
  _request(t, r) {
    typeof t == "string" ? (r = r || {}, r.url = t) : r = t || {}, r = D(this.defaults, r);
    const { transitional: n, paramsSerializer: a, headers: c } = r;
    n !== void 0 && J.assertOptions(n, {
      silentJSONParsing: O.transitional(O.boolean),
      forcedJSONParsing: O.transitional(O.boolean),
      clarifyTimeoutError: O.transitional(O.boolean)
    }, !1), a != null && (l.isFunction(a) ? r.paramsSerializer = {
      serialize: a
    } : J.assertOptions(a, {
      encode: O.function,
      serialize: O.function
    }, !0)), J.assertOptions(r, {
      baseUrl: O.spelling("baseURL"),
      withXsrfToken: O.spelling("withXSRFToken")
    }, !0), r.method = (r.method || this.defaults.method || "get").toLowerCase();
    let s = c && l.merge(
      c.common,
      c[r.method]
    );
    c && l.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (h) => {
        delete c[h];
      }
    ), r.headers = p.concat(s, c);
    const i = [];
    let f = !0;
    this.interceptors.request.forEach(function(y) {
      typeof y.runWhen == "function" && y.runWhen(r) === !1 || (f = f && y.synchronous, i.unshift(y.fulfilled, y.rejected));
    });
    const o = [];
    this.interceptors.response.forEach(function(y) {
      o.push(y.fulfilled, y.rejected);
    });
    let d, m = 0, w;
    if (!f) {
      const h = [Oe.bind(this), void 0];
      for (h.unshift.apply(h, i), h.push.apply(h, o), w = h.length, d = Promise.resolve(r); m < w; )
        d = d.then(h[m++], h[m++]);
      return d;
    }
    w = i.length;
    let v = r;
    for (m = 0; m < w; ) {
      const h = i[m++], y = i[m++];
      try {
        v = h(v);
      } catch (g) {
        y.call(this, g);
        break;
      }
    }
    try {
      d = Oe.call(this, v);
    } catch (h) {
      return Promise.reject(h);
    }
    for (m = 0, w = o.length; m < w; )
      d = d.then(o[m++], o[m++]);
    return d;
  }
  getUri(t) {
    t = D(this.defaults, t);
    const r = Ke(t.baseURL, t.url);
    return $e(r, t.params, t.paramsSerializer);
  }
}
l.forEach(["delete", "get", "head", "options"], function(t) {
  F.prototype[t] = function(r, n) {
    return this.request(D(n || {}, {
      method: t,
      url: r,
      data: (n || {}).data
    }));
  };
});
l.forEach(["post", "put", "patch"], function(t) {
  function r(n) {
    return function(c, s, i) {
      return this.request(D(i || {}, {
        method: t,
        headers: n ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: c,
        data: s
      }));
    };
  }
  F.prototype[t] = r(), F.prototype[t + "Form"] = r(!0);
});
class he {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let r;
    this.promise = new Promise(function(c) {
      r = c;
    });
    const n = this;
    this.promise.then((a) => {
      if (!n._listeners) return;
      let c = n._listeners.length;
      for (; c-- > 0; )
        n._listeners[c](a);
      n._listeners = null;
    }), this.promise.then = (a) => {
      let c;
      const s = new Promise((i) => {
        n.subscribe(i), c = i;
      }).then(a);
      return s.cancel = function() {
        n.unsubscribe(c);
      }, s;
    }, t(function(c, s, i) {
      n.reason || (n.reason = new B(c, s, i), r(n.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const r = this._listeners.indexOf(t);
    r !== -1 && this._listeners.splice(r, 1);
  }
  toAbortSignal() {
    const t = new AbortController(), r = (n) => {
      t.abort(n);
    };
    return this.subscribe(r), t.signal.unsubscribe = () => this.unsubscribe(r), t.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new he(function(a) {
        t = a;
      }),
      cancel: t
    };
  }
}
function Pr(e) {
  return function(r) {
    return e.apply(null, r);
  };
}
function Lr(e) {
  return l.isObject(e) && e.isAxiosError === !0;
}
const ue = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(ue).forEach(([e, t]) => {
  ue[t] = e;
});
function tt(e) {
  const t = new F(e), r = Ne(F.prototype.request, t);
  return l.extend(r, F.prototype, t, { allOwnKeys: !0 }), l.extend(r, t, null, { allOwnKeys: !0 }), r.create = function(a) {
    return tt(D(e, a));
  }, r;
}
const x = tt(H);
x.Axios = F;
x.CanceledError = B;
x.CancelToken = he;
x.isCancel = We;
x.VERSION = et;
x.toFormData = Q;
x.AxiosError = b;
x.Cancel = x.CanceledError;
x.all = function(t) {
  return Promise.all(t);
};
x.spread = Pr;
x.isAxiosError = Lr;
x.mergeConfig = D;
x.AxiosHeaders = p;
x.formToJSON = (e) => Ve(l.isHTMLForm(e) ? new FormData(e) : e);
x.getAdapter = Ye.getAdapter;
x.HttpStatusCode = ue;
x.default = x;
const Nr = /\{[^{}]+\}/g, ge = ({
  allowReserved: e,
  name: t,
  value: r
}) => {
  if (r == null)
    return "";
  if (typeof r == "object")
    throw new Error(
      "Deeply-nested arrays/objects aren’t supported. Provide your own `querySerializer()` to handle these."
    );
  return `${t}=${e ? r : encodeURIComponent(r)}`;
}, Ur = (e) => {
  switch (e) {
    case "label":
      return ".";
    case "matrix":
      return ";";
    case "simple":
      return ",";
    default:
      return "&";
  }
}, Fr = (e) => {
  switch (e) {
    case "form":
      return ",";
    case "pipeDelimited":
      return "|";
    case "spaceDelimited":
      return "%20";
    default:
      return ",";
  }
}, Dr = (e) => {
  switch (e) {
    case "label":
      return ".";
    case "matrix":
      return ";";
    case "simple":
      return ",";
    default:
      return "&";
  }
}, jr = ({
  allowReserved: e,
  explode: t,
  name: r,
  style: n,
  value: a
}) => {
  if (!t) {
    const i = (e ? a : a.map((f) => encodeURIComponent(f))).join(Fr(n));
    switch (n) {
      case "label":
        return `.${i}`;
      case "matrix":
        return `;${r}=${i}`;
      case "simple":
        return i;
      default:
        return `${r}=${i}`;
    }
  }
  const c = Ur(n), s = a.map((i) => n === "label" || n === "simple" ? e ? i : encodeURIComponent(i) : ge({
    allowReserved: e,
    name: r,
    value: i
  })).join(c);
  return n === "label" || n === "matrix" ? c + s : s;
}, Br = ({
  allowReserved: e,
  explode: t,
  name: r,
  style: n,
  value: a
}) => {
  if (n !== "deepObject" && !t) {
    let i = [];
    Object.entries(a).forEach(([o, d]) => {
      i = [
        ...i,
        o,
        e ? d : encodeURIComponent(d)
      ];
    });
    const f = i.join(",");
    switch (n) {
      case "form":
        return `${r}=${f}`;
      case "label":
        return `.${f}`;
      case "matrix":
        return `;${r}=${f}`;
      default:
        return f;
    }
  }
  const c = Dr(n), s = Object.entries(a).map(
    ([i, f]) => ge({
      allowReserved: e,
      name: n === "deepObject" ? `${r}[${i}]` : i,
      value: f
    })
  ).join(c);
  return n === "label" || n === "matrix" ? c + s : s;
}, kr = ({ path: e, url: t }) => {
  let r = t;
  const n = t.match(Nr);
  if (n)
    for (const a of n) {
      let c = !1, s = a.substring(1, a.length - 1), i = "simple";
      s.endsWith("*") && (c = !0, s = s.substring(0, s.length - 1)), s.startsWith(".") ? (s = s.substring(1), i = "label") : s.startsWith(";") && (s = s.substring(1), i = "matrix");
      const f = e[s];
      if (f != null) {
        if (Array.isArray(f)) {
          r = r.replace(
            a,
            jr({ explode: c, name: s, style: i, value: f })
          );
          continue;
        }
        if (typeof f == "object") {
          r = r.replace(
            a,
            Br({
              explode: c,
              name: s,
              style: i,
              value: f
            })
          );
          continue;
        }
        if (i === "matrix") {
          r = r.replace(
            a,
            `;${ge({
              name: s,
              value: f
            })}`
          );
          continue;
        }
        r = r.replace(
          a,
          i === "label" ? `.${f}` : f
        );
      }
    }
  return r;
}, Ir = ({
  path: e,
  url: t
}) => e ? kr({ path: e, url: t }) : t, Le = (e, t) => {
  const r = { ...e, ...t };
  return r.headers = oe(e.headers, t.headers), r;
}, oe = (...e) => {
  const t = {};
  for (const r of e) {
    if (!r || typeof r != "object")
      continue;
    const n = Object.entries(r);
    for (const [a, c] of n)
      if (c === null)
        delete t[a];
      else if (Array.isArray(c))
        for (const s of c)
          t[a] = [...t[a] ?? [], s];
      else c !== void 0 && (t[a] = typeof c == "object" ? JSON.stringify(c) : c);
  }
  return t;
}, rt = (e = {}) => ({
  baseURL: "",
  ...e
}), qr = (e) => {
  let t = Le(rt(), e);
  const r = x.create(t), n = () => ({ ...t }), a = (s) => (t = Le(t, s), r.defaults = {
    ...r.defaults,
    ...t,
    // @ts-ignore
    headers: oe(r.defaults.headers, t.headers)
  }, n()), c = async (s) => {
    var d;
    const i = {
      ...t,
      ...s,
      // @ts-ignore
      headers: oe(t.headers, s.headers)
    };
    i.body && i.bodySerializer && (i.body = i.bodySerializer(i.body));
    const f = Ir({
      path: i.path,
      url: i.url
    }), o = i.axios || r;
    try {
      const m = await o({
        ...i,
        data: i.body,
        params: i.query,
        url: f
      });
      let { data: w } = m;
      return i.responseType === "json" && i.responseTransformer && (w = await i.responseTransformer(w)), {
        ...m,
        data: w ?? {}
      };
    } catch (m) {
      const w = m;
      if (i.throwOnError)
        throw w;
      return w.error = ((d = w.response) == null ? void 0 : d.data) ?? {}, w;
    }
  };
  return {
    delete: (s) => c({ ...s, method: "delete" }),
    get: (s) => c({ ...s, method: "get" }),
    getConfig: n,
    head: (s) => c({ ...s, method: "head" }),
    instance: r,
    options: (s) => c({ ...s, method: "options" }),
    patch: (s) => c({ ...s, method: "patch" }),
    post: (s) => c({ ...s, method: "post" }),
    put: (s) => c({ ...s, method: "put" }),
    request: c,
    setConfig: a
  };
}, u = qr(rt()), Hr = (e) => ((e == null ? void 0 : e.client) ?? u).get({
  ...e,
  url: "/account/"
}), Mr = (e) => ((e == null ? void 0 : e.client) ?? u).get({
  ...e,
  url: "/account/account/{account_id}/"
}), zr = (e) => ((e == null ? void 0 : e.client) ?? u).get({
  ...e,
  url: "/account/accounts/"
}), $r = (e) => ((e == null ? void 0 : e.client) ?? u).get({
  ...e,
  url: "/address/address/{address_id}/near-objects/"
}), Jr = (e) => ((e == null ? void 0 : e.client) ?? u).post({
  ...e,
  url: "/address/{application_id}/select/"
}), Vr = (e) => ((e == null ? void 0 : e.client) ?? u).post({
  ...e,
  url: "/address/{application_id}/suggestion/"
}), Wr = (e) => ((e == null ? void 0 : e.client) ?? u).get({
  ...e,
  url: "/application/admin/applications/"
}), Gr = (e) => ((e == null ? void 0 : e.client) ?? u).get({
  ...e,
  url: "/application/council/applications/"
}), Kr = (e) => ((e == null ? void 0 : e.client) ?? u).post({
  ...e,
  url: "/application/create/"
}), Xr = (e) => ((e == null ? void 0 : e.client) ?? u).get({
  ...e,
  url: "/application/files/{application_id}/"
}), Qr = (e) => ((e == null ? void 0 : e.client) ?? u).get({
  ...e,
  url: "/application/files/{application_id}/{id}/"
}), Zr = (e) => ((e == null ? void 0 : e.client) ?? u).get({
  ...e,
  url: "/application/list/"
}), Yr = (e) => ((e == null ? void 0 : e.client) ?? u).get({
  ...e,
  url: "/application/retrieve/{application_id}/"
}), en = (e) => ((e == null ? void 0 : e.client) ?? u).post({
  ...e,
  url: "/application/upload-file/{application_id}/"
}), tn = (e) => ((e == null ? void 0 : e.client) ?? u).get({
  ...e,
  url: "/assessment/assessment-review-state-definition/"
}), rn = (e) => ((e == null ? void 0 : e.client) ?? u).get({
  ...e,
  url: "/assessment/conversation/{conversation_id}/assessment-review-state/{assessment_review_id}/"
}), nn = (e) => ((e == null ? void 0 : e.client) ?? u).get({
  ...e,
  url: "/assessment/conversation/{conversation_id}/assessment-review-states/"
}), an = (e) => ((e == null ? void 0 : e.client) ?? u).post({
  ...e,
  url: "/assessment/conversation/{conversation_id}/assessment-review-states/"
}), sn = (e) => ((e == null ? void 0 : e.client) ?? u).get({
  ...e,
  url: "/assessment/issue/{issue_id}/"
}), cn = (e) => ((e == null ? void 0 : e.client) ?? u).get({
  ...e,
  url: "/assessment/issues/"
}), ln = (e) => ((e == null ? void 0 : e.client) ?? u).post({
  ...e,
  url: "/assessment/issues/"
}), un = (e) => ((e == null ? void 0 : e.client) ?? u).post({
  ...e,
  url: "/auth/login/"
}), on = (e) => ((e == null ? void 0 : e.client) ?? u).get({
  ...e,
  url: "/auth/logout/"
}), dn = (e) => ((e == null ? void 0 : e.client) ?? u).post({
  ...e,
  url: "/auth/logout/"
}), fn = (e) => ((e == null ? void 0 : e.client) ?? u).post({
  ...e,
  url: "/auth/password/change/"
}), mn = (e) => ((e == null ? void 0 : e.client) ?? u).post({
  ...e,
  url: "/auth/password/reset/"
}), hn = (e) => ((e == null ? void 0 : e.client) ?? u).post({
  ...e,
  url: "/auth/password/reset/confirm/"
}), gn = (e) => ((e == null ? void 0 : e.client) ?? u).post({
  ...e,
  url: "/auth/password/reset/confirm/{uid}/{token}/"
}), bn = (e) => ((e == null ? void 0 : e.client) ?? u).post({
  ...e,
  url: "/auth/registration/"
}), yn = (e) => ((e == null ? void 0 : e.client) ?? u).post({
  ...e,
  url: "/auth/registration/resend-email/"
}), wn = (e) => ((e == null ? void 0 : e.client) ?? u).post({
  ...e,
  url: "/auth/registration/verify-email/"
}), Cn = (e) => ((e == null ? void 0 : e.client) ?? u).get({
  ...e,
  url: "/auth/social/"
}), xn = (e) => ((e == null ? void 0 : e.client) ?? u).get({
  ...e,
  url: "/auth/test/"
}), vn = (e) => ((e == null ? void 0 : e.client) ?? u).get({
  ...e,
  url: "/auth/user/"
}), Rn = (e) => ((e == null ? void 0 : e.client) ?? u).put({
  ...e,
  url: "/auth/user/"
}), En = (e) => ((e == null ? void 0 : e.client) ?? u).patch({
  ...e,
  url: "/auth/user/"
}), Sn = (e) => ((e == null ? void 0 : e.client) ?? u).post({
  ...e,
  url: "/conversation/admin/conversation/panel-test-execution/{execution_id}/update-feedback-result/"
}), _n = (e) => ((e == null ? void 0 : e.client) ?? u).patch({
  ...e,
  url: "/conversation/admin/conversation/panel-test/{test_conversation_expert_result_id}/update-feedback-result/"
}), pn = (e) => ((e == null ? void 0 : e.client) ?? u).post({
  ...e,
  url: "/conversation/admin/conversation/test/group/"
}), An = (e) => ((e == null ? void 0 : e.client) ?? u).get({
  ...e,
  url: "/conversation/admin/conversation/test/group/{group_id}/"
}), Tn = (e) => ((e == null ? void 0 : e.client) ?? u).patch({
  ...e,
  url: "/conversation/admin/conversation/test/group/{group_id}/"
}), On = (e) => ((e == null ? void 0 : e.client) ?? u).get({
  ...e,
  url: "/conversation/admin/conversation/test/groups/"
}), Pn = (e) => ((e == null ? void 0 : e.client) ?? u).post({
  ...e,
  url: "/conversation/admin/conversation/test/panel/"
}), Ln = (e) => ((e == null ? void 0 : e.client) ?? u).get({
  ...e,
  url: "/conversation/admin/conversation/test/panel/{panel_id}/"
}), Nn = (e) => ((e == null ? void 0 : e.client) ?? u).patch({
  ...e,
  url: "/conversation/admin/conversation/test/panel/{panel_id}/"
}), Un = (e) => ((e == null ? void 0 : e.client) ?? u).get({
  ...e,
  url: "/conversation/admin/conversation/test/panel/{panel_id}/results/"
}), Fn = (e) => ((e == null ? void 0 : e.client) ?? u).get({
  ...e,
  url: "/conversation/admin/conversation/test/panel/{panel_id}/results/grouped/"
}), Dn = (e) => ((e == null ? void 0 : e.client) ?? u).post({
  ...e,
  url: "/conversation/admin/conversation/test/panel/{panel_id}/run/"
}), jn = (e) => ((e == null ? void 0 : e.client) ?? u).get({
  ...e,
  url: "/conversation/admin/conversation/test/panels/"
}), Bn = (e) => ((e == null ? void 0 : e.client) ?? u).post({
  ...e,
  url: "/conversation/admin/conversation/{conversation_id}/change_panel/"
}), kn = (e) => ((e == null ? void 0 : e.client) ?? u).get({
  ...e,
  url: "/conversation/admin/conversation/{conversation_id}/expert_results/"
}), In = (e) => ((e == null ? void 0 : e.client) ?? u).post({
  ...e,
  url: "/conversation/admin/conversation/{conversation_id}/set_test_conversation_expert_execution_as_live/"
}), qn = (e) => ((e == null ? void 0 : e.client) ?? u).get({
  ...e,
  url: "/conversation/admin/conversations/"
}), Hn = (e) => ((e == null ? void 0 : e.client) ?? u).patch({
  ...e,
  url: "/conversation/admin/conversations/"
}), Mn = (e) => ((e == null ? void 0 : e.client) ?? u).get({
  ...e,
  url: "/conversation/admin/conversations/{conversation_id}/"
}), zn = (e) => ((e == null ? void 0 : e.client) ?? u).post({
  ...e,
  url: "/conversation/admin/conversations/{conversation_id}/send_to_council/"
}), $n = (e) => ((e == null ? void 0 : e.client) ?? u).post({
  ...e,
  url: "/conversation/admin/deployment/conversation/"
}), Jn = (e) => ((e == null ? void 0 : e.client) ?? u).post({
  ...e,
  url: "/conversation/admin/deployment/conversation/{conversation_id}/"
}), Vn = (e) => ((e == null ? void 0 : e.client) ?? u).post({
  ...e,
  url: "/conversation/application/{application_id}/conversation/"
}), Wn = (e) => ((e == null ? void 0 : e.client) ?? u).get({
  ...e,
  url: "/conversation/application/{application_id}/conversation/{conversation_id}/"
}), Gn = (e) => ((e == null ? void 0 : e.client) ?? u).post({
  ...e,
  url: "/conversation/application/{application_id}/conversation/{conversation_id}/message/"
}), Kn = (e) => ((e == null ? void 0 : e.client) ?? u).get({
  ...e,
  url: "/conversation/application/{application_id}/conversation/{conversation_id}/messages/"
}), Xn = (e) => ((e == null ? void 0 : e.client) ?? u).get({
  ...e,
  url: "/conversation/application/{application_id}/conversations/"
}), Qn = (e) => ((e == null ? void 0 : e.client) ?? u).get({
  ...e,
  url: "/conversation/conversation/{conversation_id}/"
}), Zn = (e) => ((e == null ? void 0 : e.client) ?? u).post({
  ...e,
  url: "/conversation/conversation/{conversation_id}/save_report/"
}), Yn = (e) => ((e == null ? void 0 : e.client) ?? u).get({
  ...e,
  url: "/conversation/conversations/"
}), ea = (e) => ((e == null ? void 0 : e.client) ?? u).get({
  ...e,
  url: "/conversation/conversations/{conversation_id}/notes/"
}), ta = (e) => ((e == null ? void 0 : e.client) ?? u).post({
  ...e,
  url: "/conversation/conversations/{conversation_id}/notes/"
}), ra = (e) => ((e == null ? void 0 : e.client) ?? u).get({
  ...e,
  url: "/conversation/conversations/{conversation_id}/reviews/"
}), na = (e) => ((e == null ? void 0 : e.client) ?? u).post({
  ...e,
  url: "/conversation/conversations/{conversation_id}/reviews/"
}), aa = (e) => ((e == null ? void 0 : e.client) ?? u).get({
  ...e,
  url: "/conversation/council/conversations/"
}), sa = (e) => ((e == null ? void 0 : e.client) ?? u).get({
  ...e,
  url: "/conversation/council/conversations/{conversation_id}/"
}), ca = (e) => ((e == null ? void 0 : e.client) ?? u).get({
  ...e,
  url: "/conversation/panels/"
}), ia = (e) => ((e == null ? void 0 : e.client) ?? u).get({
  ...e,
  url: "/conversation/public/conversation/{conversation_identifier}/"
}), la = (e) => ((e == null ? void 0 : e.client) ?? u).post({
  ...e,
  url: "/conversation/test-conversaton/create/"
}), ua = (e) => ((e == null ? void 0 : e.client) ?? u).get({
  ...e,
  url: "/conversation/{conversation_id}/messages/{message_id}/graph/"
}), oa = (e) => ((e == null ? void 0 : e.client) ?? u).get({
  ...e,
  url: "/council/council-ordinances"
}), da = (e) => ((e == null ? void 0 : e.client) ?? u).post({
  ...e,
  url: "/council/council-ordinances"
}), fa = (e) => ((e == null ? void 0 : e.client) ?? u).get({
  ...e,
  url: "/council/council/{council_id}/"
}), ma = (e) => ((e == null ? void 0 : e.client) ?? u).post({
  ...e,
  url: "/council/council/{council_id}/member/create/"
}), ha = (e) => ((e == null ? void 0 : e.client) ?? u).get({
  ...e,
  url: "/council/council/{council_id}/member/{account_id}/"
}), ga = (e) => ((e == null ? void 0 : e.client) ?? u).get({
  ...e,
  url: "/council/councils"
}), ba = (e) => ((e == null ? void 0 : e.client) ?? u).post({
  ...e,
  url: "/council/councils"
}), ya = (e) => ((e == null ? void 0 : e.client) ?? u).get({
  ...e,
  url: "/council/table-of-uses-sections"
}), wa = (e) => ((e == null ? void 0 : e.client) ?? u).post({
  ...e,
  url: "/council/table-of-uses-sections"
}), Ca = (e) => ((e == null ? void 0 : e.client) ?? u).get({
  ...e,
  url: "/council/{council_code}/annotations/"
}), xa = (e) => ((e == null ? void 0 : e.client) ?? u).get({
  ...e,
  url: "/council/{council_code}/clause/{clause_number}/annotations/"
}), va = (e) => ((e == null ? void 0 : e.client) ?? u).post({
  ...e,
  url: "/council/{council_code}/clause/{clause_number}/annotations/"
}), Ra = (e) => ((e == null ? void 0 : e.client) ?? u).patch({
  ...e,
  url: "/evaluation/evaluation-result-feedback/{evaluation_result_id}/"
}), Ea = (e) => ((e == null ? void 0 : e.client) ?? u).post({
  ...e,
  url: "/expert/compare-experts/"
}), Sa = (e) => ((e == null ? void 0 : e.client) ?? u).post({
  ...e,
  url: "/expert/compare-panels/"
}), _a = (e) => ((e == null ? void 0 : e.client) ?? u).get({
  ...e,
  url: "/expert/context-cutter/{context_cutter_id}/"
}), pa = (e) => ((e == null ? void 0 : e.client) ?? u).get({
  ...e,
  url: "/expert/context-cutter/{cutter_or_step_id}/get_experts"
}), Aa = (e) => ((e == null ? void 0 : e.client) ?? u).get({
  ...e,
  url: "/expert/context-cutters/"
}), Ta = (e) => ((e == null ? void 0 : e.client) ?? u).post({
  ...e,
  url: "/expert/council/{council_id}/set_default_panel/{panel_id}"
}), Oa = (e) => ((e == null ? void 0 : e.client) ?? u).post({
  ...e,
  url: "/expert/deployment/batch-create-context-cutter/"
}), Pa = (e) => ((e == null ? void 0 : e.client) ?? u).post({
  ...e,
  url: "/expert/deployment/batch-create-expert/"
}), La = (e) => ((e == null ? void 0 : e.client) ?? u).post({
  ...e,
  url: "/expert/deployment/batch-create-llm-model/"
}), Na = (e) => ((e == null ? void 0 : e.client) ?? u).post({
  ...e,
  url: "/expert/deployment/create-expert/"
}), Ua = (e) => ((e == null ? void 0 : e.client) ?? u).post({
  ...e,
  url: "/expert/deployment/create-panel/"
}), Fa = (e) => ((e == null ? void 0 : e.client) ?? u).post({
  ...e,
  url: "/expert/deployment/panel/set-council-panel-in-environment/"
}), Da = (e) => ((e == null ? void 0 : e.client) ?? u).post({
  ...e,
  url: "/expert/deployment/panel/{panel_id}/create-panel-in-environment/"
}), ja = (e) => ((e == null ? void 0 : e.client) ?? u).post({
  ...e,
  url: "/expert/deployment/panel/{panel_id}/initiate-set-council-panel-in-environment/"
}), Ba = (e) => ((e == null ? void 0 : e.client) ?? u).get({
  ...e,
  url: "/expert/expert-config-types/"
}), ka = (e) => ((e == null ? void 0 : e.client) ?? u).post({
  ...e,
  url: "/expert/expert/execute-expert-draft/"
}), Ia = (e) => ((e == null ? void 0 : e.client) ?? u).get({
  ...e,
  url: "/expert/expert/{expert_id}/"
}), qa = (e) => ((e == null ? void 0 : e.client) ?? u).get({
  ...e,
  url: "/expert/expert/{expert_id}/full-prompt/"
}), Ha = (e) => ((e == null ? void 0 : e.client) ?? u).post({
  ...e,
  url: "/expert/expert/{expert_id}/get-expert-inputs-from-conversation/"
}), Ma = (e) => ((e == null ? void 0 : e.client) ?? u).get({
  ...e,
  url: "/expert/experts-grouped/"
}), za = (e) => ((e == null ? void 0 : e.client) ?? u).get({
  ...e,
  url: "/expert/experts-list/"
}), $a = (e) => ((e == null ? void 0 : e.client) ?? u).get({
  ...e,
  url: "/expert/experts/"
}), Ja = (e) => ((e == null ? void 0 : e.client) ?? u).post({
  ...e,
  url: "/expert/experts/"
}), Va = (e) => ((e == null ? void 0 : e.client) ?? u).post({
  ...e,
  url: "/expert/experts/set_archive/{expert_name}/{archive}/"
}), Wa = (e) => ((e == null ? void 0 : e.client) ?? u).get({
  ...e,
  url: "/expert/llm_providers/"
}), Ga = (e) => ((e == null ? void 0 : e.client) ?? u).get({
  ...e,
  url: "/expert/panels/"
}), Ka = (e) => ((e == null ? void 0 : e.client) ?? u).post({
  ...e,
  url: "/expert/panels/"
}), Xa = (e) => ((e == null ? void 0 : e.client) ?? u).post({
  ...e,
  url: "/expert/panels/set_archive/{panel_version}/{archive}/"
}), Qa = (e) => ((e == null ? void 0 : e.client) ?? u).get({
  ...e,
  url: "/expert/panels/{panel_id}/"
}), Za = (e) => ((e == null ? void 0 : e.client) ?? u).get({
  ...e,
  url: "/expert/panels/{panel_id}/graph/"
}), Ya = (e) => ((e == null ? void 0 : e.client) ?? u).get({
  ...e,
  url: "/schemas/"
}), es = (e) => ((e == null ? void 0 : e.client) ?? u).get({
  ...e,
  url: "/schemas/{model_name}/"
}), ts = (e) => ((e == null ? void 0 : e.client) ?? u).get({
  ...e,
  url: "/utils/command-center-data-fetch/"
}), rs = (e) => ((e == null ? void 0 : e.client) ?? u).get({
  ...e,
  url: "/utils/content-type/"
}), ns = (e) => ((e == null ? void 0 : e.client) ?? u).get({
  ...e,
  url: "/utils/healthcheck/"
}), as = (e) => ((e == null ? void 0 : e.client) ?? u).get({
  ...e,
  url: "/utils/tag/"
}), ss = (e) => ((e == null ? void 0 : e.client) ?? u).post({
  ...e,
  url: "/utils/tag/"
}), cs = (e) => ((e == null ? void 0 : e.client) ?? u).get({
  ...e,
  url: "/utils/tag/{id}/"
}), is = (e) => ((e == null ? void 0 : e.client) ?? u).get({
  ...e,
  url: "/utils/tagged-item/"
}), ls = (e) => ((e == null ? void 0 : e.client) ?? u).post({
  ...e,
  url: "/utils/tagged-item/"
}), us = (e) => ((e == null ? void 0 : e.client) ?? u).get({
  ...e,
  url: "/utils/tagged-item/{id}/"
}), os = (e) => ((e == null ? void 0 : e.client) ?? u).put({
  ...e,
  url: "/utils/tagged-item/{id}/"
}), ds = (e) => ((e == null ? void 0 : e.client) ?? u).delete({
  ...e,
  url: "/utils/tagged-item/{id}/"
}), fs = (e) => ((e == null ? void 0 : e.client) ?? u).post({
  ...e,
  url: "/vendor/webhook/linear/"
});
export {
  qn as $,
  mn as A,
  hn as B,
  gn as C,
  bn as D,
  yn as E,
  wn as F,
  Cn as G,
  xn as H,
  vn as I,
  Rn as J,
  En as K,
  Sn as L,
  _n as M,
  pn as N,
  An as O,
  Tn as P,
  On as Q,
  Pn as R,
  Ln as S,
  Nn as T,
  Un as U,
  Fn as V,
  Dn as W,
  jn as X,
  Bn as Y,
  kn as Z,
  In as _,
  Hr as a,
  Xa as a$,
  Hn as a0,
  Mn as a1,
  zn as a2,
  $n as a3,
  Jn as a4,
  Vn as a5,
  Wn as a6,
  Gn as a7,
  Kn as a8,
  Xn as a9,
  Ea as aA,
  Sa as aB,
  _a as aC,
  pa as aD,
  Aa as aE,
  Ta as aF,
  Oa as aG,
  Pa as aH,
  La as aI,
  Na as aJ,
  Ua as aK,
  Fa as aL,
  Da as aM,
  ja as aN,
  Ba as aO,
  ka as aP,
  Ia as aQ,
  qa as aR,
  Ha as aS,
  Ma as aT,
  za as aU,
  $a as aV,
  Ja as aW,
  Va as aX,
  Wa as aY,
  Ga as aZ,
  Ka as a_,
  Qn as aa,
  Zn as ab,
  Yn as ac,
  ea as ad,
  ta as ae,
  ra as af,
  na as ag,
  aa as ah,
  sa as ai,
  ca as aj,
  ia as ak,
  la as al,
  ua as am,
  oa as an,
  da as ao,
  fa as ap,
  ma as aq,
  ha as ar,
  ga as as,
  ba as at,
  ya as au,
  wa as av,
  Ca as aw,
  xa as ax,
  va as ay,
  Ra as az,
  Mr as b,
  Qa as b0,
  Za as b1,
  Ya as b2,
  es as b3,
  ts as b4,
  rs as b5,
  ns as b6,
  as as b7,
  ss as b8,
  cs as b9,
  is as ba,
  ls as bb,
  us as bc,
  os as bd,
  ds as be,
  fs as bf,
  u as c,
  zr as d,
  $r as e,
  Jr as f,
  Vr as g,
  Wr as h,
  Gr as i,
  Kr as j,
  Xr as k,
  Qr as l,
  Zr as m,
  Yr as n,
  en as o,
  tn as p,
  rn as q,
  nn as r,
  an as s,
  sn as t,
  cn as u,
  ln as v,
  un as w,
  on as x,
  dn as y,
  fn as z
};
//# sourceMappingURL=services.gen-72h9jWK3.js.map
